export default "__VITE_ASSET__3505ab1f__"